'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var core = require('@tiptap/core');

const Text = core.Node.create({
    name: 'text',
    group: 'inline',
});

exports.Text = Text;
exports["default"] = Text;
//# sourceMappingURL=index.cjs.map
